import { render, staticRenderFns } from "./TransactionsMenu.vue?vue&type=template&id=64a4ebce&scoped=true&"
import script from "./TransactionsMenu.vue?vue&type=script&lang=js&"
export * from "./TransactionsMenu.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsMenu.vue?vue&type=style&index=0&id=64a4ebce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a4ebce",
  null
  
)

export default component.exports